<template>
  <v-app>
    <AppNavBar />
    <v-main>
      <router-view />
      <AppFooter />
    </v-main>
  </v-app>
</template>

<script>
import AppNavBar from './components/AppNavBar.vue';
import AppFooter from './components/AppFooter.vue';

export default {
  name: 'App',
  components: { AppNavBar, AppFooter }
};
</script>

<style>
* { box-sizing: border-box; }
body {
  font-family: 'Open Sans', Arial, sans-serif;
  color: #444;
  margin: 0;
  padding: 0;
}
a { color: var(--brand-red); text-decoration: none; }
a:hover { text-decoration: underline; }

/* Page header banner (used on inner pages) */
.page-header {
  position: relative;
  height: 200px;
  background: linear-gradient(135deg, #002633 0%, #003d52 50%, #1a0010 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.page-header-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(135deg, rgba(0,38,51,0.88), rgba(150,10,10,0.55));
}
.page-header-content {
  position: relative;
  z-index: 2;
  text-align: center;
}
.page-header-title {
  color: white;
  font-size: clamp(1.8rem, 4vw, 2.8rem);
  font-weight: 800;
}

/* Section badge pill */
.section-badge {
  display: inline-block;
  background: rgba(94, 34, 29, 0.1);
  color: var(--brand-red);
  font-size: 0.78rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 2px;
  padding: 5px 14px;
  border-radius: 50px;
  border: 1px solid rgba(94, 34, 29, 0.25);
}
.section-title {
  font-size: 2rem;
  font-weight: 800;
  color: #002633;
  line-height: 1.2;
}
.section-title.on-dark { color: white; }
.section-divider {
  width: 56px;
  height: 3px;
  background: var(--brand-red);
  margin: 16px auto 0;
  border-radius: 2px;
}
</style>
